function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C5.746 0 3.8 1.629 2.375 3.719.949 5.809 0 8.469 0 11c0 3.91 1.93 6.934 4.75 8.25C6.063 22.031 9.043 24 13 24c2.512 0 5.152-.95 7.25-2.375C22.348 20.199 24 18.258 24 16c0-2.254-1.629-4.2-3.719-5.625-1.367-.934-2.968-1.672-4.625-2.063-.48-1.957-1.418-3.87-2.625-5.374C11.684 1.258 9.961 0 8 0zm0 2c1.04 0 2.348.79 3.469 2.188.84 1.05 1.578 2.421 2.031 3.812-.164-.008-.336 0-.5 0-5.293 0-9 3.594-9 8 0 .117-.004.23 0 .344C2.79 15.148 2 13.355 2 11c0-2.012.82-4.383 2.031-6.156C5.242 3.07 6.797 2 8 2zm5 8c2.012 0 4.383.82 6.156 2.031C20.93 13.242 22 14.797 22 16c0 1.195-1.098 2.758-2.875 3.969C17.348 21.179 14.988 22 13 22c-4.535 0-7-2.66-7-6 0-3.324 2.566-6 7-6z",
  fill: "#BCC9CE"
});

function SvgEgg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgEgg;